/* eslint-disable react-refresh/only-export-components */

import { createFileRoute } from '@tanstack/react-router';
import { IntegrationsTab } from '@/app/(client)/network/-components/companyProfileTabs/integrations/IntegrationsTab';
import { useCompanyDetail } from '@/app/(client)/network/-hooks/useCompanyDetail';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/integrations/',
)({
  component: IntegrationsRoute,
});

function IntegrationsRoute() {
  const { companyId } = Route.useParams();
  const { data: company } = useCompanyDetail(companyId);
  const user = useSessionStore(s => s.user);
  const isOwnCompany = user?.companyId === (company?.forCompanyId ?? companyId);
  return <IntegrationsTab companyId={companyId} isOwnCompany={isOwnCompany} />;
}
